module.exports = __webpack_public_path__ + "static/img/13bixin.273ec555.gif";